module.exports = __webpack_public_path__ + "img/bookings.9cee7f12.svg";